<template>
  <input
    class="form-control form-control-lg"
    type="text"
    :value="value"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  padding: 20px 25px;
  border-radius: 8px;
  font-size: 22px;
}
</style>
